import { createContext, ReactNode, useContext } from 'react';

import { getIpLocation } from '@gn-audio/jss-core';

import { useAsync } from '../../../utils/hooks/useAsync';

export interface ClientLocation {
  countryCode?: string;
}
export const ClientLocationContext = createContext<ClientLocation>({});

export const useClientLocation = () => {
  return useContext(ClientLocationContext);
};

export const ClientLocationProvider = ({ children }: { children: ReactNode }) => {
  const clientLocation = useAsync(getIpLocation, []);

  return (
    <ClientLocationContext.Provider value={clientLocation ?? {}}>
      {children}
    </ClientLocationContext.Provider>
  );
};
